exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mv-22 {\n  margin: 22px 0;\n}\n.v-middle {\n  vertical-align: middle !important;\n}\n.badge-success {\n  background-color: #28a745 !important;\n}\n.badge-danger {\n  background-color: #dc3545 !important;\n}\n.ShowColor {\n  border-radius: 10px;\n  width: 50%;\n  margin: 0 auto;\n}\n.star {\n  color: gold;\n}\n", ""]);

// exports
